import { createSlice } from "@reduxjs/toolkit";


const ConformationBoxSlice = createSlice({
    name: 'ConformationBox',
    initialState: {
        isDeleteRole: false,
        isDeleteUser: false,
        isDeleteMenu: false,
        isDeleteProduct: false,
        isCallDisposition: false,
        isCall: false,
        isOperatingSystem: false,
        isCustomer: false,
        isIpAddress: false,
        isknowledgeBase: false,
        IsInvioce: false,
        IsDelete: false,
    },
    reducers: {
        setIsDeleteRole(state, action) {
            state.isDeleteRole = !state.isDeleteRole;
        },
        setIsDeleteUser(state) {
            state.isDeleteUser = !state.isDeleteUser;
        },
        setIsDeleteMenu(state) {
            state.isDeleteMenu = !state.isDeleteMenu;
        },
        setIsDeleteProduct(state) {
            state.isDeleteProduct = !state.isDeleteProduct;
        },
        setIsDeleteCallDisposition(state) {
            state.isCallDisposition = !state.isCallDisposition;
        },
        setIsDeleteCall(state) {
            state.isCall = !state.isCall;
        },
        setIsDeleteOperatingSystem(state) {
            state.isOperatingSystem = !state.isOperatingSystem;
        },
        setIsDeleteCustomer(state) {
            state.isCustomer = !state.isCustomer;
        },
        setIsDeleteIpDevice(state) {
            state.isIpAddress = !state.isIpAddress;
        },
        setIsDeleteknowledgeBase(state) {
            state.isknowledgeBase = !state.isknowledgeBase;
        },
        setIsDeleteInvioce(state) {
            state.IsInvioce = !state.IsInvioce;
        },
        setIsDelete(state) {
            state.IsDelete = !state.IsDelete;
        },
       
    }

})

export const { setIsDeleteRole, setIsDeleteUser, setIsDelete,  setIsDeleteInvioce, setIsDeleteMenu, setIsDeleteknowledgeBase, setIsDeleteProduct,setIsDeleteCustomer, setIsDeleteCallDisposition, setIsDeleteCall,setIsDeleteOperatingSystem, setIsDeleteIpDevice } = ConformationBoxSlice.actions;
export default ConformationBoxSlice;